module.exports = __webpack_public_path__ + "static/alfastuc-renovatie-102cb361334db89516170d2d419d6472.jpg";